import React from 'react';
import PropTypes from 'prop-types';
import { Image as SaaghiImage } from '@takhfifan/saaghi';

function Image(props) {
	return <SaaghiImage {...props} />;
}

Image.propTypes = {
	alt: PropTypes.string.isRequired,
	className: PropTypes.string,
	isForceCheckEnable: PropTypes.bool,
	loop: PropTypes.bool,
	height: PropTypes.number,
	width: PropTypes.number,
};

export default Image;
